import { useTranslation } from 'react-i18next';

interface Expert {
  name: string;
  title: string;
  quote: string;
  initials: string;
  avatar?: string;
}

export default function EndorsementsSection() {
  const { t } = useTranslation();

  const experts: Expert[] = [
    {
      name: t('endorsement_1_name'),
      title: t('endorsement_1_title'),
      quote: t('endorsement_1_quote'),
      initials: 'BK',
      avatar: '/images/expert-kennedy.png',
    },
    {
      name: t('endorsement_2_name'),
      title: t('endorsement_2_title'),
      quote: t('endorsement_2_quote'),
      initials: 'WHT',
      avatar: '/images/expert-wang-huating.png',
    },
    {
      name: t('endorsement_3_name'),
      title: t('endorsement_3_title'),
      quote: t('endorsement_3_quote'),
      initials: 'WR',
      avatar: '/images/expert-wang-rui.png',
    },
    {
      name: t('endorsement_4_name'),
      title: t('endorsement_4_title'),
      quote: t('endorsement_4_quote'),
      initials: 'ZCT',
      avatar: '/images/expert-zhang-cuntai.png',
    },
  ];

  return (
    <section id="endorsements" className="py-10 md:py-12 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {t('endorsements_title')}
            </h2>
            <div className="w-14 h-1 bg-accent-500 mx-auto mt-5 rounded-full" />
          </div>

          {/* Expert cards */}
          <div className="grid grid-cols-1 gap-5 md:gap-6">
            {experts.map((expert, index) => {
              const isEven = index % 2 === 0;

              return (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
                >
                  <div className={`flex items-start gap-4 md:gap-5 ${isEven ? '' : 'md:flex-row-reverse'}`}>
                    {/* Avatar */}
                    {expert.avatar ? (
                      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden flex-shrink-0 border-2 border-accent-200">
                        <img
                          src={expert.avatar}
                          alt={expert.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <div className="w-16 h-16 md:w-20 md:h-20 bg-secondary-100 rounded-full flex items-center justify-center flex-shrink-0 border-2 border-secondary-200">
                        <span className="font-heading text-secondary-700 text-sm md:text-base font-bold">
                          {expert.initials}
                        </span>
                      </div>
                    )}

                    <div className="min-w-0 flex-1">
                      <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                        {expert.name}
                      </h3>
                      <p className="text-foreground-500 text-xs md:text-sm mt-1 leading-relaxed whitespace-pre-line">
                        {expert.title}
                      </p>

                      <div className="relative mt-4">
                        <i className="ri-double-quotes-l text-accent-500/50 text-3xl md:text-4xl absolute -top-2 -left-1 leading-none"></i>
                        <p className="text-foreground-700 text-xs md:text-sm leading-relaxed pl-7 md:pl-9 pr-6 md:pr-8">
                          {expert.quote}
                        </p>
                        <i className="ri-double-quotes-r text-accent-500/50 text-3xl md:text-4xl absolute -bottom-2 right-0 leading-none"></i>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}